import {Icon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "12",
  viewBox: "0 0 16 12",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M5.5.186v2.066a8.96 8.96 0 0 0-3.864 2.284L.222 3.12A10.949 10.949 0 0 1 5.5.186zm5 0c1.934.45 3.77 1.428 5.278 2.935l-1.414 1.415A8.96 8.96 0 0 0 10.5 2.252V.186zm-5 4.345V6.74c-.37.213-.719.479-1.036.796L3.05 6.12a6.975 6.975 0 0 1 2.45-1.59zm5 0c.893.34 1.73.87 2.45 1.59l-1.414 1.415A5.007 5.007 0 0 0 10.5 6.74V4.53zM8 12a1 1 0 1 1 0-2 1 1 0 0 1 0 2zM7 1h2v8H7V1z",
      fill: "currentColor",
      "fill-rule": "nonzero"
    }, null, -1)
  ]))]))
}
export default { render() { return h(Icon, {icon: {render}, name: "icon-bad-connection"}) } }